const config = {
  baseURL : 'https://api.f1secaas.co.kr/v1',
  baseSignalR : 'https://ws.f1secaas.co.kr',
  // baseURL : 'http://localhost:5001/v1',
  // baseSignalR : 'http://localhost:5001',
  manual : "f1-uwss.en.partner.manual.latest.pdf",
  version : "2022.01"
}

export default config;
